import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Card, Image, Label, Button, Icon, Header, Grid } from 'semantic-ui-react';
import _ from 'underscore';
import Color from 'color';

import Utils from 'utils/Utils.js';
import {mod} from 'utils/MathUtils.js';
import {colors, fontSizes, fonts, spacings, layout, shadow, shadowLight, buttons} from 'style';
import defaultChallengeImage from 'img/default-challenge-image.jpg';
import './carousel.css';

const cBorderRadius = 9;
const cWidth = 310;
const cHeight = 195;
const magFactor = 1.2;

var style= {
    content: {
        lineHeight: '1.5',
        ...fonts.body,
    },
    carouselWrapper: {
        position: 'relative',
        height: '290px',
        overflow: 'hidden',
    },
    carouselItem: {
        position: 'absolute',
        left: '-85px',
        top: spacings.base,
        boxShadow: shadow,
        borderRadius: cBorderRadius+'px',
        height: cHeight+'px',
        width: cWidth+'px',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        transition: 'left 1s, top 1s, transform 1s, z-index 1s',
        cursor: 'pointer',
        left: '50%'
    },
    dots: {
        position: 'relative',
        top: '260px',
        textAlign: 'center',
    },
    dotWrapper: {
        display: 'inline-block',
        cursor: 'pointer',
    },
    activeDotWrapper: {
        cursor: 'auto',
    },
    dot: {
        width: spacings.tiny,
        height: spacings.tiny,
        backgroundColor: Color(colors.themeBlue).alpha(0.5).toString(),
        borderRadius: '50%',
        margin: '4px',
    },
    activeDot: {
        backgroundColor: colors.themeBlue,
    },
    gradient: {
        width: '100%',
        height: '100%',
        background: 'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0), rgba(0,0,0,0))',
        borderRadius: cBorderRadius+'px',
    },
    textArea: {
        position: 'absolute',
        bottom: '0px',
        left: '0px',
        width: '100%',
        paddingTop: spacings.tiny,
        paddingBottom: spacings.tiny,
        paddingLeft: spacings.tiny,
        paddingRight: '60px',
    },
    title: {
        color: '#fff',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        ...fonts.bodyL,
    },
    description: {
        color: '#fff',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        ...fonts.bodyS,
    },
    ribbon: {
        height: '30px',
        position: 'absolute',
        top: spacings.small,
        right: '-4px',
        marginLeft: '-100px',
        backgroundColor: colors.pointsYellow,
        color: '#fff',
        padding: '4px',
        textAlign: 'center',
        ...fonts.bodyS,
    },
    ribbonContent: {
        width: '100%',
        height: '100%',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    ribbonEdge: {
        borderLeft: '8px solid transparent',
        borderRight: '8px solid transparent',
        borderTop: '15px solid ' + colors.pointsYellow,
        borderBottom: '15px solid ' + colors.pointsYellow,
        position: 'absolute',
        left: '-8px',
        top: '0px',
        height: '0px',
        width: '0px',
    },
    resourceBanner: {
        position: 'absolute',
        right: spacings.tiny,
        bottom: spacings.tiny,
        borderRadius: '100px',
        backgroundColor: '#fff',

    },
    starIcon: {
        fontSize: '1em',
        opacity: '1',
        color: colors.pointsYellow,
    },
    resourceIcon: {
        fontSize: '1em',
        opacity: '1',
        color: colors.themeBlue,
    },
};


function getCurrentIndex(offset, carouselItems) {
    return mod(offset, carouselItems.length || 1);
}
function getCarouselInfo(i, offset, carouselItems, carouselPositions) {
    var info = {};
    info.style = {};
    var numSideItems = Math.floor(carouselPositions.length/2);
    var carouselItemIndex = mod(i - numSideItems, carouselItems.length || 1);
    var carouselItem = carouselItems[carouselItemIndex];
    var carouselPositionIndex = mod(((i-offset)), (carouselPositions.length || 1));
    var carouselPosition = carouselPositions[carouselPositionIndex].position;
    var noTransition = carouselPositions[carouselPositionIndex].noTransition;
    info.style.backgroundImage = Utils.url(Utils.deref(carouselItem, 'banner.url') || defaultChallengeImage);
    var xOffset = (carouselPosition*(cWidth+24) - cWidth/2);
    var yOffset = 24;

    if(carouselItems.length===1 && carouselPosition!==0) {
        return null;
    }

    var transform = [];
    transform.push('translateX('+xOffset+'px)');
    if(carouselPosition==0) {
        transform.push('scale('+magFactor+')');
    }
    info.style = {...info.style, transform: transform.join(' ')};
    info.style.top = yOffset + 'px';
    if(noTransition) {
        info.style.transition = 'none';
    }

    info.style.zIndex = 1000 - Math.abs(carouselPosition);

    info.carouselItemIndex = carouselItemIndex;
    info.carouselPositionIndex = carouselPositionIndex;
    info.carouselItem = carouselItem;
    info.carouselPosition = carouselPosition;



    return info;
}

function getCarousels(offset, carouselItems, carouselPositions) {
    return carouselPositions.map((cp,i) => getCarouselInfo(i, offset, carouselItems, carouselPositions));
}

const Carousel = ({t,
                   carouselItems,
                   carouselPositions,
                   offset,
                   onClickCarousel,
                   onClickCarouselIndicator,
                   onNavigate,
                }) => (
    <div style={style.content}>
        {Boolean(carouselItems && carouselItems.length>0) &&
        <div className='carousel-wrapper' style={style.carouselWrapper}>
            <div className='carousel-images'>

                {getCarousels(offset, carouselItems, carouselPositions).map((info,i) =>
                    info!=null &&
                    <div key={i} 
                         style={{...style.carouselItem,
                                ...info.style
                                }}
                         onClick={()=>onClickCarousel(info)}>
                            <div style={style.gradient}>
                                {Boolean(info.carouselItem.ribbon) &&
                                    <div style={style.ribbon}>
                                        <div style={style.ribbonEdge}></div>
                                        <div style={style.ribbonContent}>
                                            {info.carouselItem.ribbon}
                                        </div>
                                    </div>
                                }
                                <div style={style.textArea}>
                                    <div style={style.title}>{info.carouselItem.title}</div>
                                    <div style={style.description}>{info.carouselItem.description}</div>
                                    {Boolean(info.carouselItem.points>0 || info.carouselItem.resources>0) &&
                                        <div style={style.resourceBanner}>
                                            {Boolean(info.carouselItem.points>0) &&
                                                <Icon style={style.starIcon} className="notClickable icon-star"/> 
                                            }

                                            {Boolean(info.carouselItem.resources>0) &&
                                                <Icon style={style.resourceIcon} className="notClickable icon-Optimollar"/>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                    </div> 
                )}

            </div>
            <div style={style.dots} className='carousel-dots'>
                {carouselItems.map((carouselItem,i) => 
                    <div key={i}
                         style={{...style.dotWrapper, ...(getCurrentIndex(i-offset, carouselItems)===0 && style.activeDotWrapper)}} 
                         onClick={()=>onClickCarouselIndicator(i, offset, carouselItems)} > 
                         <div style={{...style.dot, ...(getCurrentIndex(i-offset, carouselItems)===0 && style.activeDot)}} />
                    </div>
                )}
            </div>
        </div>
        }
    </div>
)

export default translate('challenges')(Carousel);



// WEBPACK FOOTER //
// ./src/modules/challenges/Carousel.js